class PromotionCampaignService extends BaseService
	@register angular.module 'App.Service'
	@inject(
		'PromotionBenefitProductsRepository'
		'PromotionBenefitProductCategoriesRepository'
		'PROMOTION_CONSTANTS'
		'BACKEND_PROMOTION_BENEFIT_TYPE'
		'BACKEND_PROMOTION_QUALIFICATION_TYPE'
		'BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE'
		'PromotionEligibleSetsRepository'
		'PromotionRepository'
		'ProductRepository'
		'ShopRepository'
		'ShopGroupRepository'
		'ConfigurationService'
	)

	###
	# @param forCampaigns - whether to query for Promotion Campaigns or Predefined Discounts
	###
	getQuery: (forCampaigns = true, query = null) ->
		if _.isEmpty(query)
			query = @PromotionRepository.createQuery()

		if forCampaigns
			entityType = @BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE.PROMOTION_CAMPAIGN
		else
			entityType = @BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE.PREDEFINED_DISCOUNT

		query.criteria 'entity_type', '=', entityType
		query.sortBy('date_from', 'DESC')

		return query

	queryShops: (name) ->
		query = @ShopRepository.createQuery()
		query.setPagination 0, 10
		query.sortBy 'name', 'ASC'
		query.criteria 'name', 'LIKE', name if angular.isDefined name

		@ShopRepository.findByQuery query

	queryShopGroups: (name) ->
		query = @ShopGroupRepository.createQuery()
		query.setPagination 0, 10
		query.sortBy 'name', 'ASC'
		if angular.isDefined name
			query.criteria 'name', 'LIKE', name

		return @ShopGroupRepository.findByQuery query

	queryBenefitShops: (filters) ->
		query = @ShopRepository.createQuery()
		query.criteria 'name', 'LIKE', filters.name if angular.isDefined filters.name
		query.criteria 'id', 'NOT IN', filters.ids.join(',') if angular.isDefined filters.ids
		query.sortBy 'name', 'ASC'

		@ShopRepository.getEntities query

	getProductQuery: (filters, pagination) ->
		query = @ProductRepository.createQuery()
		query.setPagination(pagination.page * pagination.limit, pagination.limit) if pagination

		if angular.isDefined(filters.name) && filters.name != ''
			criteria = @ProductRepository.addSkuCriteria(query, filters.name)
			criteria
				.or('name', 'LIKE', filters.name)
				.or('id', 'LIKE', filters.name)

		query.with('product_variants')
		query.sortBy(filters.sort.column, if filters.sort.direction == true then 'ASC' else 'DESC') if angular.isDefined(filters.sort)

		return query

	queryBenefitProducts: (filters) ->
		query = @getProductQuery filters
		query.with('product_categories', 'product_data', 'product_variants>product_data')
		query.criteria('id', '=', filters.category_id) if angular.isDefined filters.category_id

		@ProductRepository.getEntities query, false, true

	loadDiscount: (id) ->
		query = @getQuery()
		query.with(
			'customer_group',
			'benefit',
			'shops',
			'benefit_products',
			'benefit_products>products',
			'benefit_products>product_variants',
			'benefit_products>products>product_variants',
			'benefit_products>products>product_categories'
		)

		if @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableShopGroups'
			query.with 'shop_groups'

		@PromotionRepository.getEntity id, query

	loadPromotionBenefitProductsByCampaignId: (campaignId) ->
		return @PromotionBenefitProductsRepository.loadByPromotionCampaignId campaignId

	loadPromotionBenefitProductCategoriesByCampaignId: (campaignId) ->
		return @PromotionBenefitProductCategoriesRepository.loadByPromotionCampaignId campaignId

	loadPromotionEligibleSetsByCampaignId: (campaignId) ->
		return @PromotionEligibleSetsRepository.loadByPromotionCampaignId campaignId

	remove: (promotionModel) ->
		@PromotionRepository.delete promotionModel.data().id

	persist: (data, isNew = false) ->
		@PromotionRepository.save data, isNew

	injectPromotion: (data) ->
		return new PromotionCampaignModel(data, @PROMOTION_CONSTANTS, @BACKEND_PROMOTION_BENEFIT_TYPE, @BACKEND_PROMOTION_QUALIFICATION_TYPE)

	getProcessedBenefitProductsForSave: (benefitProducts) ->
		return _.chain(benefitProducts)
			.filter (product) -> product.selected
			.map (product) ->
				variants = _.filter product.product_variants, (variant) -> variant.selected
				variants = _.map variants, (variant) ->
					{
						product_variant_id: variant.id
						retail_price: variant.retail_price
					}

				return {
					product_id: product.id
					retail_price: product.retail_price
					product_variants: variants
				}
			.value()

	getProcessedEligibleSetsForSave: (benefitProducts) ->
		return _.chain(benefitProducts)
			.filter (product) -> product.selected
			.map (product) ->
				variants = _.filter product.product_variants, (variant) -> variant.selected

				if variants.length == product.product_variants.length
					variants = []
				else
					variants = _.pluck variants, 'id'

				return {
					product_id: product.id
					retail_price: product.retail_price
					product_variants: variants
				}
			.value()
